<template>
  <v-row>
    <v-col cols="auto" class="pb-0">
      <h6>{{ title }}</h6>
    </v-col>

    <v-col cols="12">
      <v-treeview
        :items="formattedData"
        item-text="message"
        item-key="id"
        open-on-click
        hoverable
        transition
        rounded
        dense
      >
        <!-- ICONO -->
        <template #prepend="{ item, open }">
          <v-icon :small="item.nodeType === 'option'" :color="item.nodeType === 'option' ? 'grey' : 'secondary'">
            {{
              item.nodeType === "option"
                ? "mdi-radiobox-marked"
                : open
                ? "mdi-folder-open-outline"
                : "mdi-folder-outline"
            }}
          </v-icon>
        </template>

        <!-- LABEL -->
        <template #label="{ item }">
          <span :class="{ 'font-weight-medium': item.hasSubmenu }">
            {{ item.message }}
          </span>
        </template>

        <!-- ACCIONES -->
        <template #append="{ item }">
          <!-- Editar -->
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-btn icon v-on="on" @click="editItem(item)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Actualizar</span>
          </v-tooltip>

          <!-- Agregar hijo (SOLO SUBMENU) -->
          <!-- <v-tooltip bottom v-if="item.hasSubmenu">
            <template #activator="{ on }">
              <v-btn icon v-on="on" @click="registerChildren(item)">
                <v-icon small>mdi-plus-circle</v-icon>
              </v-btn>
            </template>
            <span>Agregar opción</span>
          </v-tooltip> -->

          <v-tooltip bottom v-if="item.nodeType === 'submenu' || item.nodeType === 'option'">
            <template #activator="{ on }">
              <v-btn icon v-on="on" @click="registerChildren(item)">
                <v-icon small>mdi-plus-circle</v-icon>
              </v-btn>
            </template>

            <span>
              {{ item.nodeType === "submenu" ? "Agregar opción" : "Agregar submenú" }}
            </span>
          </v-tooltip>

          <!-- Eliminar (SOLO HOJAS) -->
          <v-tooltip bottom v-if="canDelete(item)">
            <template #activator="{ on }">
              <v-btn icon v-on="on" @click="deleteItem(item)">
                <v-icon small>mdi-trash-can-outline</v-icon>
              </v-btn>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
      </v-treeview>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    title: String,
    data: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    formattedData() {
      return this.normalizeTree(this.data);
    },
  },

  methods: {
    /**
     * Normaliza opciones y submenus en estructura árbol (infinita)
     */
    normalizeTree(items = []) {
      return items.map((item) => {
        // ─────────────────────────────
        // CASO 1: OPCIÓN SIMPLE
        // ─────────────────────────────
        if (!item.sub_menu && !item.is_sub_menu) {
          return {
            ...item,
            nodeType: "option",
            hasSubmenu: false,
            children: [],
          };
        }

        // ─────────────────────────────
        // CASO 2: OPCIÓN QUE TIENE SUBMENU
        // ─────────────────────────────
        if (item.sub_menu) {
          return {
            ...item,
            nodeType: "option-with-submenu",
            hasSubmenu: true,
            children: [
              {
                id: `submenu-${item.sub_menu.id}`,
                nodeType: "submenu",
                is_sub_menu: 1,

                // datos reales del submenu
                ...item.sub_menu,

                message: item.sub_menu.name,
                parentOptionId: item.id,

                children: this.normalizeTree(item.sub_menu.options || []),
              },
            ],
          };
        }

        // ─────────────────────────────
        // CASO 3: SUBMENU REAL
        // ─────────────────────────────
        if (item.is_sub_menu) {
          return {
            ...item,
            nodeType: "submenu",
            hasSubmenu: true,
            children: this.normalizeTree(item.options || item.children || []),
          };
        }
      });
    },

    /**
     * Solo se puede eliminar si no tiene hijos
     */
    canDelete(item) {
      return !item.children || item.children.length === 0;
    },

    editItem(item) {
      this.$emit("item:edit", item, true);
    },

    registerChildren(item) {
      this.$emit("item:createChild", item);
    },

    deleteItem(item) {
      this.$emit("item:delete", item);
    },
  },
};
</script>
